import { render } from "./BaseInplace.vue?vue&type=template&id=6d7833a7&scoped=true"
import script from "./BaseInplace.vue?vue&type=script&lang=js"
export * from "./BaseInplace.vue?vue&type=script&lang=js"

import "./BaseInplace.vue?vue&type=style&index=0&id=6d7833a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7833a7"]])

export default __exports__